import type { FunctionComponent } from 'react';

import { CurrencyConnected } from '@pp/core/src/components/currency/CurrencyConnected';
// import { useFeature } from '@pp/core/src/components/featureConfig/FeatureConfigFlags';
// import { usePromoTrophyConnected } from '@pp/core/src/components/promotionsV2/helper/hooks/usePromoTrophyConnected';
// import { mapToNewTrophy } from '@pp/core/src/components/promotionsV2/helper/utils';
import { useBetSlice } from '@pp/core/src/store/slices/bets/selectors';
import { useTrophy } from '@pp/core/src/hooks/helpers/useTrophy';
import { useIsLargerThanWide } from '@pp/core/src/styles/hooks/media';
import {useNetPositionConnected} from '@pp/core/src/hooks/useNetPositionConnected';

import { TotalBetWing } from '../totalBetWing/TotalBetWing';

export const TotalBetWingConnected: FunctionComponent = () => {
  const net = useNetPositionConnected();

  const totalBet = useBetSlice.totalBet();
  const trophy = useTrophy();
  // const promov2: boolean = useFeature('isPromotionsV2');
  // const newTrophy = usePromoTrophyConnected();
  const inDesktopMode = useIsLargerThanWide();
  return (
    // <TotalBetWing
    //   trophy={promov2 ? newTrophy : mapToNewTrophy(trophy)}
    //   totalBet={<CurrencyConnected value={totalBet} />}
    //   netPosition={net !== undefined && inDesktopMode && <CurrencyConnected value={net} />}
    // />

    <TotalBetWing trophy={trophy} totalBet={<CurrencyConnected value={totalBet} />} 
    netPosition={net !== undefined && inDesktopMode && <CurrencyConnected value={net} />}/>
  );
};
